import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { TypeAnimation } from "react-type-animation";
import { Link, useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import "./Team.css";

export const executiveMembers = [
  {
    id: "ameet-parikh",
    name: "Ameet Parikh",
    title: "Founder & Partner",
    bio: "Ameet Parikh is the Founder and Partner at Morphis, bringing over three decades of distinguished experience in professional services, strategic consulting, and corporate governance. Known for his expertise in family business advisory, mergers and acquisitions (M&A), and operational scaling, Ameet previously co-founded Tranzmute Capital and established Axis Risk Consulting, which was later acquired by Genpact. His foundational career includes serving as a senior partner and leadership team member at Arthur Andersen and Ernst & Young. A Chartered Accountant and a law graduate from Mumbai University, he also lends his strategic insights to several corporate boards as an independent director, driving sustainable growth and robust governance across diverse industries.",
    tags: ["Family Business Advisory", "M&A", "Corporate Governance"],
    image: "/assets/team/ameet-parikh.webp",
    short_image: "/assets/team/ameet-parikh.webp",
    shortDescription:
      "Veteran business advisor with global risk consulting expertise.",
    linkedin: "https://www.linkedin.com/in/ameet-parikh-30407222/",
  },
  {
    id: "rahul-kapani",
    name: "Rahul Kapani",
    title: "Founder & Partner",
    bio: "Rahul is a Sydenham College graduate and a Chartered Accountant by training. He began his career in 1994, working with large organizations such as Andersen, WNS, Genpact, and True North Private Equity, building a strong foundation in how businesses operate at scale and across cycles. In 2019, he founded Morphis Management Services and now works as a deal maker and advisor. He partners closely with Private Equity firms and family-owned businesses, helping them navigate transactions, growth decisions, and complex transitions. Rahul thrives at the intersection of strategy, numbers, and people, and the relationship-driven nature of advisory work.",
    tags: ["Private Equity", "Deal Advisory", "Value Creation"],
    image: "/assets/team/1_rahul-kapani.webp",
    short_image: "/assets/team/rahul-kapani.webp",
    shortDescription:
      "Private equity advisor driving complex business transactions.",
    linkedin: "https://www.linkedin.com/in/rahulkapani/",
  },
  {
    id: "vimal-taparia",
    name: "Vimal Taparia",
    title: "Partner",
    bio: "Vimal is a qualified Chartered Accountant and has over 18 years of experience spanning private equity, corporate finance, risk advisory, and business management, with prior roles at True North Private Equity, Meru Mobility Tech (where he rose to CFO), Ernst & Young, and Goldman Sachs. A founding member of Morphis in 2019, Vimal co-leads the firm's work with VC/PE funds, founders, and CXOs across the investment lifecycle, from deal screening and execution to post-investment value creation, IPO readiness, and exit planning. He also advises founders and corporates on fundraising, capital structuring, M&A, and monetisation.",
    tags: ["IPO Readiness", "M&A", "Capital Structuring"],
    image: "/assets/team/1_vimal-taparia.webp",
    short_image: "/assets/team/vimal-taparia.webp",
    shortDescription: "Corporate finance leader specializing in IPO readiness.",
    linkedin: "https://www.linkedin.com/in/vimaltaparia22/",
  },
];

export const teamMembers = [
  {
    id: "ameet-parikh",
    name: "Ameet Parikh",
    title: "Founder & Partner",
    bio: "Ameet Parikh is the Founder and Partner at Morphis, bringing over three decades of distinguished experience in professional services, strategic consulting, and corporate governance. Known for his expertise in family business advisory, mergers and acquisitions (M&A), and operational scaling, Ameet previously co-founded Tranzmute Capital and established Axis Risk Consulting, which was later acquired by Genpact. His foundational career includes serving as a senior partner and leadership team member at Arthur Andersen and Ernst & Young. A Chartered Accountant and a law graduate from Mumbai University, he also lends his strategic insights to several corporate boards as an independent director, driving sustainable growth and robust governance across diverse industries.",
    tags: ["Family Business Advisory", "M&A", "Corporate Governance"],
    image: "/assets/team/ameet-parikh.webp",
    short_image: "/assets/team/ameet-parikh.webp",
    shortDescription:
      "Veteran business advisor with global risk consulting expertise.",
    linkedin: "https://www.linkedin.com/in/ameet-parikh-30407222/",
  },
   {
    id: "rahul-kapani",
    name: "Rahul Kapani",
    title: "Founder & Partner",
    bio: "Rahul is a Sydenham College graduate and a Chartered Accountant by training. He began his career in 1994, working with large organizations such as Andersen, WNS, Genpact, and True North Private Equity, building a strong foundation in how businesses operate at scale and across cycles. In 2019, he founded Morphis Management Services and now works as a deal maker and advisor. He partners closely with Private Equity firms and family-owned businesses, helping them navigate transactions, growth decisions, and complex transitions. Rahul thrives at the intersection of strategy, numbers, and people, and the relationship-driven nature of advisory work.",
    tags: ["Private Equity", "Deal Advisory", "Value Creation"],
    image: "/assets/team/1_rahul-kapani.webp",
    short_image: "/assets/team/rahul-kapani.webp",
    shortDescription:
      "Private equity advisor driving complex business transactions.",
    linkedin: "https://www.linkedin.com/in/rahulkapani/",
  },
  {
    id: "vimal-taparia",
    name: "Vimal Taparia",
    title: "Partner",
    bio: "Vimal is a qualified Chartered Accountant and has over 18 years of experience spanning private equity, corporate finance, risk advisory, and business management, with prior roles at True North Private Equity, Meru Mobility Tech (where he rose to CFO), Ernst & Young, and Goldman Sachs. A founding member of Morphis in 2019, Vimal co-leads the firm's work with VC/PE funds, founders, and CXOs across the investment lifecycle, from deal screening and execution to post-investment value creation, IPO readiness, and exit planning. He also advises founders and corporates on fundraising, capital structuring, M&A, and monetisation.",
    tags: ["IPO Readiness", "M&A", "Capital Structuring"],
    image: "/assets/team/1_vimal-taparia.webp",
    short_image: "/assets/team/vimal-taparia.webp",
    shortDescription: "Corporate finance leader specializing in IPO readiness.",
    linkedin: "https://www.linkedin.com/in/vimaltaparia22/",
  },
  {
    id: "isha-shah-kejriwal",
    name: "Isha Shah Kejriwal",
    title: "",
    bio: "Isha is a strategic deal maker at Morphis partnering closely with Private Equity firms and family-owned businesses to navigate high-stakes private transactions and IPOs. Prior to joining Morphis in 2022, she was a Director in EY's Corporate Tax practice and played a pivotal role in the Tax Markets function to drive the practice's strategic growth. She qualified as a Chartered Accountant in 2006 and holds dual degrees in Commerce and Law. Outside of work, Isha is an avid lectiophile and a fan of stand-up comedy.",
    tags: ["Corporate Tax", "Private Transactions", "IPO Advisory"],
    image: "/assets/team/1_isha-shah-kejriwal.webp",
    short_image: "/assets/team/isha-shah-kejriwal.webp",
    shortDescription: "Strategic dealmaker with expertise in IPO advisory.",
    linkedin: "https://www.linkedin.com/in/isha-shah-kejriwal/",
  },
  {
    id: "viral-chotai",
    name: "Viral Chotai",
    title: "",
    bio: "Viral is a Chartered Accountant with 16+ years of experience across private equity, corporate finance, valuations, and business management, with prior roles at KPMG and True North Private Equity. In his current role, Viral focuses on exit planning, transaction structuring, and driving end-to-end deal execution to ensure timely and efficient closures. Outside of work, Viral is an avid traveller and enjoys discovering the best vegetarian dining experiences around the world.",
    tags: ["Exit Planning", "Transaction Structuring", "Valuation"],
    image: "/assets/team/1_viral-chotai.webp",
    short_image: "/assets/team/viral-chotai.webp",
    shortDescription: "Transaction specialist focused on exits and valuations.",
    linkedin: "https://www.linkedin.com/in/viral-chotai-61632919/",
  },
  {
    id: "kashish-changrani",
    name: "Kashish Changrani",
    title: "",
    bio: "Kashish is a finance professional with 15+ years of experience across corporate credit analysis, private markets analytics, and financial services portfolio intelligence, with prior experience at CRISIL focusing on credit assessment and financial risk analysis across sectors. She holds an MBA in Finance. In her current role, Kashish focuses on financial services benchmarking, portfolio performance analytics, and valuation enablement, supporting investment decisions and ongoing portfolio monitoring across Banks, NBFCs, AMCs, Wealth, and Insurance platforms. Kashish is an avid traveller and enjoys exploring new places, with a quiet appreciation for culinary experimentation.",
    tags: ["Portfolio Analytics", "Financial Services", "Benchmarking"],
    image: "/assets/team/1_kashish-changrani.webp",
    short_image: "/assets/team/kashish-changrani.webp",
    shortDescription:
      "Financial analytics expert supporting investment performance decisions.",
    linkedin: "https://www.linkedin.com/in/kashish-changrani-3459144/",
  },
  {
    id: "sannidhi-bindal",
    name: "Sannidhi Bindal",
    title: "",
    bio: "Sannidhi is part of the Morphis Management team, providing portfolio monitoring and business management services to private equity and private credit clients. She works with portfolio companies' leadership teams throughout the investment cycle, driving value creation, monitoring, and strategic decision-making, while also supporting end-to-end exit execution. She has over 8 years of experience across PE portfolio monitoring, financial due diligence, and credit fund oversight. Prior to Morphis, she was at L&T Infotech (LTI) in business finance, and before that at PwC Mumbai in assurance. Sannidhi is a qualified Chartered Accountant and Chartered Financial Analyst (CFA). She is passionate about dancing and loves to explore new places.",
    tags: ["Portfolio Monitoring", "Due Diligence", "Private Credit"],
    image: "/assets/team/1_sannidhi-bindal.webp",
    short_image: "/assets/team/sannidhi-bindal.webp",
    shortDescription:
      "Portfolio monitoring expert driving private equity value.",
    linkedin: "https://www.linkedin.com/in/sannidhi-bindal-586aa0102/",
  },
  {
    id: "vinni-rajani",
    name: "Vinni Rajani",
    title: "",
    bio: "Experienced management professional skilled in team leadership, workplace relations, communication, resiliency, and conflict prevention.",
    tags: ["Team Building", "Workplace relations"],
    image: "/assets/team/1_vinni-rajani.webp",
    short_image: "/assets/team/vinni-rajani.webp",
    shortDescription:
      "Management professional focused on leadership and workplace relations.",
    linkedin: "https://www.linkedin.com/in/vinni-rajani-314b556/",
  },
  {
    id: "tushar-panchal",
    name: "Tushar Panchal",
    title: "",
    bio: "Tushar is a member of the Morphis Management team, where he provides portfolio monitoring and business management services to private equity and family office clients. He works with leadership teams throughout the investment cycle to drive value creation, oversee strategic decision-making, and manage investor reporting. Additionally, he supports end-to-end exit execution. He is a qualified Chartered Financial Analyst (CFA). He enjoys playing carrom and staying informed on geopolitical affairs.",
    tags: ["Investor Reporting", "Portfolio Monitoring", "Value Creation"],
    image: "/assets/team/1_tushar-panchal.webp",
    short_image: "/assets/team/tushar-panchal.webp",
    shortDescription:
      "CFA professional specializing in portfolio performance management.",
    linkedin: "https://www.linkedin.com/in/tushar-panchal-8729641b2/",
  },
  {
    id: "pinal-khetan",
    name: "Pinal Khetan",
    title: "",
    bio: "Pinal is part of the Morphis Management team, providing business management and transaction support services to private equity clients. She works with portfolio companies across the investment lifecycle, supporting performance monitoring, financial analysis, and strategic decision-making. A Chartered Accountant with an All India Rank (AIR 35), Pinal brings experience from Deloitte's Strategy, Risk & Transactions practice, where she built and reviewed financial models across multiple sectors. Prior to that, she was at EY in assurance, supporting audits of listed and high-growth e-commerce and IT companies. Outside of work, Pinal is an avid traveller with a creative streak and a love for dance and music.",
    tags: [
      "Financial Modelling",
      "Transaction Support",
      "Performance Monitoring",
    ],
    image: "/assets/team/1_pinal-khetan.webp",
    short_image: "/assets/team/pinal-khetan.webp",
    shortDescription:
      "Financial modelling expert supporting strategic investment transactions.",
    linkedin: "https://www.linkedin.com/in/pinal-khetan-b2397520a/",
  },
  {
    id: "shrey-sisodiya",
    name: "Shrey Sisodiya",
    title: "",
    bio: "Shrey is part of the Morphis team providing deal execution and transaction support for PE exits and family office investments. He works with clients across the deal lifecycle, from diligence and transaction structuring through to closing, with experience in investment analysis, financial modelling, and valuation. He has over 3 years of experience across audit and has led and performed audits spanning manufacturing, real estate, and infrastructure sectors. Shrey is a qualified Chartered Accountant and a graduate of H.R. College. He enjoys reading geopolitical affairs, current events, and political satire.",
    tags: ["Deal Execution", "Financial Modelling", "Valuation"],
    image: "/assets/team/1_shrey-sisodiya.webp",
    short_image: "/assets/team/shrey-sisodiya.webp",
    shortDescription:
      "Deal execution specialist focused on investment transaction support.",
    linkedin: "https://www.linkedin.com/in/shreysisodiya/",
  },
  {
    id: "dhanesh-gianani",
    name: "Dhanesh Gianani",
    title: "",
    bio: "Dhanesh Gianani is a Chartered Accountant with experience across assurance & financial analysis. He is currently part of Morphis Capital & Management, where he supports Private Equity clients. Prior to joining Morphis, he completed his articleship at EY within the Technology, Media, and Telecommunications (TMT) assurance practice, working with high-growth companies. Dhanesh is also actively engaged in financial markets and investment research, with a niche expertise in IPOs.He enjoys writing and sharing insights on listed equities, global macro & IPO's. ",
    tags: ["Financial Analysis", "Research", "Portfolio Support"],
    image: "/assets/team/1_dhanesh-gianani.webp",
    short_image: "/assets/team/dhanesh-gianani.webp",
    shortDescription:
      "Financial analyst specializing in research and IPO insights.",
    linkedin: "https://www.linkedin.com/in/dhaneshgianani/",
  },
  {
    id: "priyanshu-chaurasia",
    name: "Priyanshu Chaurasia",
    title: "",
    bio: "Priyanshu is part of the Morphis Capital & Management team, working across private equity and private credit investments. He supports transactions, portfolio monitoring, and financial analysis, with experience in financial due diligence, 3-statement modeling, and investment monitoring across sectors including healthcare, IT services, consumer, and financial services. He has over 3 years of experience across private equity, private credit, and assurance. Prior to Morphis, he was with G. M. Kapadia & Co. in audit and assurance. Priyanshu is a CFA Level III candidate and holds a Bachelor of Commerce from the University of Mumbai. He enjoys high-altitude trekking and badminton.",
    tags: [
      "Financial Due Diligence",
      "Investment Monitoring",
      "3-Statement Modelling",
    ],
    image: "/assets/team/1_priyanshu-chaurasia.webp",
    short_image: "/assets/team/priyanshu-chaurasia.webp",
    shortDescription:
      "Investment analyst experienced in diligence and portfolio monitoring.",
    linkedin: "https://www.linkedin.com/in/priyanshu-chaurasia-934a911a5/",
  },
  {
    id: "harsh-patel",
    name: "Harsh Patel",
    title: "",
    bio: "Harsh is part of the Morphis Capital team, specializing in FS Benchmarking for Private Equity clients. He delivers data-driven insights by monitoring company performance, analyzing key metrics, and evaluating client portfolio companies against their peers. He works across lending businesses, asset & wealth management, and insurance companies, translating complex datasets into concise, decision-relevant insights to support performance assessment. Harsh holds a Bachelor’s degree in Accounting and Finance and has over three years of experience. Outside of work, he enjoys travelling and exploring new destinations.",
    tags: [
      "FS Benchmarking",
      "Performance Analytics",
      "Private Equity Support",
    ],
    short_image: "/assets/team/harsh-patel.webp",
    image: "/assets/team/1_harsh-patel.webp",
    shortDescription:
      "Benchmarking analyst delivering data-driven private equity insights.",
    linkedin: "https://www.linkedin.com/in/harsh-patel-8723561bb/",
  },
];

const sortedTeamMembers = [...teamMembers].sort((a, b) => {
  const lastNameA = a.name.split(" ").slice(1).join(" ");
  const lastNameB = b.name.split(" ").slice(1).join(" ");

  return lastNameA.localeCompare(lastNameB);
});

const filteredTeamMembers = sortedTeamMembers.filter(
  (member) =>
    member.id !== "rahul-kapani" &&
    member.id !== "vimal-taparia" &&
    member.id !== "ameet-parikh"
);

const Team = () => {
  const teamHeaderRef = useRef(null);
  const [showPartners, setShowPartners] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    AOS.refresh();

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !showPartners) {
          setShowPartners(true);
          observer.unobserve(entry.target); // Stop observing after triggering
        }
      },
      {
        threshold: 0.3, // Lower threshold for earlier trigger
        rootMargin: "0px 0px -50px 0px",
      }
    );

    // Use a small delay to ensure the ref is attached
    const timeoutId = setTimeout(() => {
      if (teamHeaderRef.current) {
        observer.observe(teamHeaderRef.current);
      }
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [showPartners]); // Add showPartners to dependencies

  return (
    <>
      <Breadcrumb />
      
      {/* Hero Section */}
      <header
        className="page-hero"
        data-aos="fade-up"
        style={{ textAlign: "center" }}
      >
        <div
          className="museum-wrap"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span className="section-label">Executive Team</span>
          <h1>
            Meet The{" "}
            <span className="highlight">
              <TypeAnimation
                sequence={["Leadership"]}
                speed={250}
                cursor={false}
              />
            </span>
          </h1>
        </div>
      </header>

      {/* Executive Members Grid */}
      <section className="team-grid-section">
        <div className="museum-wrap">
          <div className="team-grid--three-cards">
            {executiveMembers.map((member, index) => {
              return (
                <Link
                  to={`/team/${member.id}`}
                  key={member.id}
                  className="member-card-link"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="member-card">
                    <div className="member-photo" style={{ width: "140px", height: "140px" }}>
                      <img src={member.short_image} alt={member.name} />
                      <div className="member-arrow-circle">
                        <i className="fas fa-plus"></i>
                      </div>
                    </div>
                    <div className="member-header">
                      <div>
                        <span className="member-name-inline">
                          {member.name}
                        </span>
                        <div className="member-designation">{member.title}</div>
                      </div>
                    </div>
                    <div className="member-card-body">
                      <p className="member-card-bio">
                        {member.shortDescription ||
                          (member.bio
                            ? member.bio.substring(0, 120)
                            : "No bio available")}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* The People Section with Typing Effect */}
      <header
        ref={teamHeaderRef}
        className="page-team-about"
        data-aos="fade-up"
        style={{ paddingTop: 0 }}
      >
        <div className="museum-wrap">
          <span className="section-label">The People</span>
          <h2>
            Practitioners,{" "}
            <span className="highlight" style={{ fontStyle: "italic" }}>
              {showPartners && (
                <TypeAnimation
                  sequence={["not Advisors."]}
                  speed={250}
                  cursor={false}
                />
              )}
            </span>
          </h2>
        </div>
      </header>

      {/* Team Members Grid */}
      <section className="team-grid-section">
        <div className="museum-wrap">
          <div className="team-grid">
            {filteredTeamMembers.map((member, index) => (
              <Link
                to={`/team/${member.id}`}
                key={member.id}
                className="member-card-link"
                data-aos="fade-up"
                data-aos-delay={index * 50}
              >
                <div className="member-card">
                  <div className="member-photo">
                    <img src={member.short_image} alt={member.name} />
                    <div className="member-arrow-circle">
                      <i className="fas fa-plus"></i>
                    </div>
                  </div>
                  <div className="member-header">
                    <div>
                      <span className="member-name-inline">{member.name}</span>
                      <div className="member-designation">{member.title}</div>
                    </div>
                  </div>
                  <div className="member-card-body">
                    <p className="member-card-bio">
                      {member.shortDescription ||
                        (member.bio
                          ? member.bio.substring(0, 120)
                          : "No bio available")}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

/* Individual Team Member Component */
export const TeamMember = () => {
  const { memberId } = useParams();
  const navigate = useNavigate();
  const member = teamMembers.find((m) => m.id === memberId);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  if (!member)
    return (
      <div
        className="museum-wrap"
        style={{ paddingTop: 120, paddingBottom: 80 }}
      >
        <p>Team member not found.</p>
        <button
          className="btn-outline"
          onClick={() => navigate("/team")}
          style={{ marginTop: 24 }}
        >
          Back to Team
        </button>
      </div>
    );

  return (
    <>
      <Breadcrumb />
      <section className="member-detail-section">
        <div className="museum-wrap">
          <button
            className="back-btn"
            onClick={() => navigate("/team")}
            data-aos="fade-right"
          >
            <i className="fa fa-arrow-left"></i> Back to Team
          </button>
          <div className="member-detail-grid">
            <div className="member-detail-photo" data-aos="zoom-in">
              <img src={member.image} alt={member.name} />
            </div>
            <div className="member-detail-content" data-aos="fade-left">
              <span className="section-label">Team Morphis</span>
              <h1 className="member-detail-name">{member.name}</h1>
              <div className="member-detail-title">{member.title}</div>
              <div className="about-text-content">
                <p>{member.bio}</p>
              </div>
              <div className="member-detail-tags">
                {member.tags.map((tag) => (
                  <span key={tag} className="member-tag">
                    {tag}
                  </span>
                ))}
              </div>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary member-detail-linkedin"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;